import { render, staticRenderFns } from "./NbPanel.vue?vue&type=template&id=cc4c22e0"
import script from "./NbPanel.vue?vue&type=script&lang=js"
export * from "./NbPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports